import { render, staticRenderFns } from "./TransEvidence.vue?vue&type=template&id=12bf7632&scoped=true&"
import script from "./TransEvidence.vue?vue&type=script&lang=js&"
export * from "./TransEvidence.vue?vue&type=script&lang=js&"
import style0 from "./TransEvidence.vue?vue&type=style&index=0&id=12bf7632&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf7632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
